// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tg9v","name":"Header_name__rQqIc","birthday":"Header_birthday__2a3ux","skeleton":"Header_skeleton__3Vtvp"};